import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import {ConfigProvider} from './ConfigContext';

ReactDOM.render(<ConfigProvider><App/></ConfigProvider>, document.getElementById('root'));
